import React from 'react'
import { Link } from 'react-router-dom'
import Faq from './Faq'
import Safe from './Safe'
import WhyChoose from './WhyChoose'
import { UploadSimple } from 'phosphor-react'

const Branding = () => {
  return (
    <>
    <div className="banner-allpage-sec">
        <ul className="breadcrumb">
            <li><Link to="/face-analyser/">Home</Link></li>
            <li>Video</li>
            <li>Branding</li>
        </ul>
        <div className="banner-content-sec text-center">
            <h1 className="first-head">Branding</h1>
            <h3 className="second-head">Fast, simple and easy to use tool you'll love.</h3>
            <br/>
            <Link to="/face-analyser/Editor/ImageEditor" className="button orange" style={{fontSize:26, borderRadius:10, padding:"15px 30px"}}>
            <UploadSimple size={32} />
                Upload Image
            </Link>
            <p className="txt-eg">or drop a file here CTRL+V to paste image or URL</p>
        </div>
    </div>
    <Safe/>
    <WhyChoose/>
    <Faq/>
    </>
  )
}

export default Branding